import { Box, Stack, Typography } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Add as AddIcon } from "@mui/icons-material";
import AcxButton from "components/UI/AcxButton/AcxButton";
import { JsonSchemaArray } from "./types";

interface ArrayItemsEditorProps {
    schema: JsonSchemaArray;
    onRemoveItem: () => void;
    onOpenAddDialog: () => void;
    isItemLocked?: () => boolean;
}

export function ArrayItemsEditor({
    schema,
    onRemoveItem,
    onOpenAddDialog,
    isItemLocked = () => false,
}: ArrayItemsEditorProps) {
    const item = schema.items;

    return (
        <Box>
            <Typography variant="h6" mt={3} mb={1}>
                Array Item
            </Typography>
            {item ? (
                <Stack direction="column" spacing={1} mb={2}>
                    <Stack
                        direction="row"
                        paddingBlock={1}
                        paddingInline={2}
                        justifyContent="space-between"
                        alignItems="center"
                        borderRadius={1}
                        sx={(theme) => ({
                            backgroundColor: theme.palette.lightgray.main,
                        })}
                    >
                        <Box>
                            <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                            >
                                Items Schema
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                                {item.title || item.type}
                            </Typography>
                        </Box>
                        <AcxButton
                            size="small"
                            variant="text"
                            color="error"
                            startIcon={<DeleteIcon />}
                            onClick={() => onRemoveItem()}
                            disabled={isItemLocked()}
                        >
                            Remove
                        </AcxButton>
                    </Stack>
                </Stack>
            ) : (
                <Typography variant="body2" color="textSecondary" mb={2}>
                    No item schema defined yet
                </Typography>
            )}
            {!item && (
                <AcxButton
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={onOpenAddDialog}
                    fullWidth
                >
                    Add Item
                </AcxButton>
            )}
        </Box>
    );
}
